import React from "react";
import { Navigate } from "react-router-dom";

export const AuthWrapper = ({ children }) => {
    const isAdmin = localStorage.getItem("isAdmin") === "true";

    if (!isAdmin) {
        localStorage.clear();
        return <Navigate to="/login" replace />;
    }

    return children;
};



export const LoginAuthWrapper = ({ children }) => {
    const token = localStorage.getItem("authToken");
    const isAdmin = localStorage.getItem("isAdmin") === "true";

    if (token && isAdmin) {
        return <Navigate to="/analytics/overview" replace />;
    }

    return children;
};
